import {
  images,
  scrolling,
} from 'assets/utilities';

import './article.scss';

const copyTextFallback = function copyTextToClipboardFallback(text) {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.top = 0;
  textArea.style.left = 0;
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  return new Promise((resolve, reject) => {
    if (document.execCommand('copy')) {
      resolve();
    } else {
      reject();
    }
    document.body.removeChild(textArea);
  });
};

const copyText = function copyTextToClipboard(text) {
  if (!navigator.clipboard) {
    return copyTextFallback(text);
  }

  return navigator.clipboard.writeText(text);
};

const onCopyClick = function onArticleCopyLinkClick(ev) {
  ev.preventDefault();
  const el = ev.currentTarget;
  const span = el.querySelector('span');
  span.originalCopy = span.originalCopy || span.innerText;
  const link = el.getAttribute('href');

  copyText(link)
    .then(() => {
      span.innerHTML = `${span.originalCopy} - Done!`;
    })
    .catch(() => {
      span.innerHTML = `${span.originalCopy} - Error!`;
    });
};

const destroy = function destroyArticle() {
  [].forEach.call(
    document.querySelectorAll('.js-articleLink'),
    el => el.removeEventListener('click', onCopyClick),
  );
};

const init = function initArticle() {
  window.scrollTo(0, 0);
  scrolling.rebuildCache();
  images.init();

  [].forEach.call(
    document.querySelectorAll('.js-articleLink'),
    el => el.addEventListener('click', onCopyClick),
  );
};

export default {
  destroy,
  init,
};
